import { useReveal } from "@/hooks/use-reveal";
import { FadeImg } from "@/components/fade-img";

/**
 * Drop your photo URLs/paths here — 4 photos work best for the layout.
 * Use images from /public (e.g. "/your-photo.jpg") or Cloudinary URLs.
 */
const POLAROIDS = [
  { src: "https://res.cloudinary.com/dnggmrgmu/image/upload/w_500,f_auto,q_auto/v1783264947/about_snkv6q.jpg", rotate: -6, alt: "Behind the scenes" },
  { src: "https://res.cloudinary.com/dnggmrgmu/image/upload/w_500,f_auto,q_auto/v1783264955/rack_gizulm.jpg", rotate: 4, alt: "The rack" },
  { src: "https://res.cloudinary.com/dnggmrgmu/image/upload/w_500,f_auto,q_auto/v1783264960/market_gpovuc.jpg", rotate: -3, alt: "The market stand" },
  { src: "https://res.cloudinary.com/dnggmrgmu/image/upload/w_500,f_auto,q_auto/v1783264952/pizza-steve_hleqnv.png", rotate: 7, alt: "Steve" },
];

export function PolaroidGallery() {
  const ref = useReveal();

  return (
    <section
      ref={ref}
      className="reveal relative mx-auto max-w-5xl px-4 py-20 sm:py-32 overflow-x-hidden"
    >
      <div className="relative mx-auto flex h-[420px] max-w-3xl items-center justify-center sm:h-[480px]">
        {POLAROIDS.map((p, i) => {
          // Spread them across the available space
          const positions = [
            { left: "2%", top: "10%" },
            { left: "30%", top: "0%" },
            { left: "52%", top: "22%" },
            { left: "72%", top: "5%" },
          ];
          const pos = positions[i] || { left: "10%", top: "10%" };
          return (
            <div
              key={i}
              className="absolute w-[42%] max-w-[220px] bg-white p-2.5 pb-8 shadow-[0_8px_24px_rgba(0,0,0,0.4)] transition-transform duration-300 hover:z-20 hover:scale-105"
              style={{
                left: pos.left,
                top: pos.top,
                transform: `rotate(${p.rotate}deg)`,
                zIndex: i,
              }}
            >
              <div className="aspect-square w-full overflow-hidden bg-card">
                <FadeImg src={p.src} alt={p.alt} className="h-full w-full object-cover" />
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
}
